export default {
    facility_1: 'Pre-Vessel Quarantine',
    facility_2: 'Vessel',
    facility_3: 'School/Daycare',
    facility_10000: 'All',
};
